import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorElearningOverviewCategoryVm } from '../operator-elearning-overview-category-vm.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningOverviewCategoriesService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningOverviewCategories`;
  }
  get(search?: string, categoryIds?: number[], topicIds?: number[], examGuids?: string[]): Observable<IOperatorElearningOverviewCategoryVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (search !== undefined && search !== null) {
      params = params.set('search', search);
    }
    if (categoryIds !== undefined && categoryIds !== null) {
      categoryIds.forEach((id) => {
        params = params.append('categoryIds', id.toString());
      });
    }
    if (topicIds !== undefined && topicIds !== null) {
      topicIds.forEach((id) => {
        params = params.append('topicIds', id.toString());
      });
    }
    if (examGuids !== undefined && examGuids !== null) {
      examGuids.forEach((guid) => {
        params = params.append('examGuids', guid);
      });
    }
    return this.http.get<IOperatorElearningOverviewCategoryVm[]>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
